import GeneratedChannelStore from "./generated/GeneratedChannelStore"

class ChannelStore extends GeneratedChannelStore {

}

export const channelStore = new ChannelStore()
